export default {
  filters (state) {
    const filtersEntries = Object.entries(state.filterAttributes).filter(
      ([k, { options }]) =>
        !['private_auction', 'distance'].includes(k) || options.length > 0
    )

    return Object.fromEntries(filtersEntries)
  }
}
